<template>
  <div class="navigation-item" :class="{
      'is-active': isActive || isActiveParent,
      'is-active-parent': isActiveParent,
      toplevel: isTopLevel,
      'badge-has-changed': bagdeChanged > 0,
    }" :color="isActive || isActiveParent ? 'primary' : null">
    <abo-feature-badge v-if="restrictedToActiveSubscription"></abo-feature-badge>    
    
    <a class="main-route" :href="targetRoute" @click="navigateTo($event)">
      <ion-icon v-if="icon" :icon="icon" slot="start" />
      <span class="label" v-if="label" v-text="label"></span>

      <span class="badge" v-if="badge" v-text="badge"></span>
    </a>
    <div class="sub-navigation" v-if="hasChildren">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { IonIcon } from "@ionic/vue";
import AboFeatureBadge from "../components/AboFeatureBadge.vue";
</script>
<script>

export default {
  props: ["label", "icon", "route", "params", "badge", "restrictedToActiveSubscription"],
  data() {
    return {
      isTopLevel: false,
      hasChildren: false,
      bagdeChanged: 0,
      badgeCountLoaded: false
    }
  },
  mounted() {
    if (this.$el) {
      let parentNavItem = this.$el.parentElement.closest(".navigation-item");
      if (!parentNavItem) {
        this.isTopLevel = true;
      }
    }
    if (this.$slots && this.$slots.default) {
      let numberOfChildren = this.$slots.default().length;
      if (numberOfChildren > 0) {
        this.hasChildren = true;
      }
    }

  },
  computed: {
    targetRoute() {
      try {
        const route = this.$router.resolve({ name: this.route });
        return route ? route : null;
      } catch (error) {
        return null;
      }
    },
    targetHref() {
      return this.targetRoute ? this.targetRoute.href : null;
    },
    isActive() {
      return this.targetRoute && this.$route.name == this.targetRoute.name;
    },
    isActiveParent() {
      //ionic doesnt work with child nodes
      if (!this.targetRoute) {
        return false;
      }
      return this.$route.path.startsWith(this.targetRoute.path + "/");
    },
  },
  methods: {
    navigateTo(event) {
      event.preventDefault();
      this.$router.push(this.targetRoute)

      if (!this.hasChildren) {
        document.body.getElementsByTagName('ion-menu')[0].close();
      }

    },

    beep() {
      try {
        var snd = new Audio(
          "data:audio/wav;base64,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"
        );
        snd.play();
      } catch (error) {
        console.log("error playing audio", error);
      }
    },
  },
  watch: {
    badge(newValue, oldValue) {
      // console.log('badge changed', newValue, oldValue, this.badgeCountLoaded)

      if (this.badgeCountLoaded && newValue > oldValue) {
        this.bagdeChanged++;
        setTimeout(() => {
          this.bagdeChanged--;
        }, 5000);
        this.beep();
      }
      this.badgeCountLoaded = true;
    },
  },
}
</script>
<style scoped>
.navigation-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  padding-right: 4px;
  background-color: transparent;
}

.main-route {
  cursor: pointer;
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
  padding-left: 1.7rem;
  padding-right: 1rem;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 400;
}

.main-route .label {
  flex: 1;
  text-decoration: none;
  color: var(--ion-color-medium);
}

.main-route ion-icon {
  visibility: hidden;
  color: var(--ion-color-medium);
  margin-right: 0.7rem;
}

.navigation-item.is-active>.main-route .label {
  flex: 1;
  text-decoration: none;
  color: var(--ion-color-primary);
}

.navigation-item.is-active>.main-route ion-icon {
  color: var(--ion-color-primary);
}

.navigation-item.is-active {
  padding-right: 0;
}

.navigation-item.is-active>.main-route {
  border-right: 4px solid var(--ion-color-primary);
  background-color: #f1f2f4 !important;
}

.navigation-item.is-active-parent>.main-route {
  border-right: none;
  background-color: #f1f2f4 !important;
  border-right: 4px solid var(--ion-color-primary);
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.03);
}

.badge {
  display: inline-block;
  position: relative;
  border: 1px solid var(--ion-color-primary);
  border-radius: 2rem;
  min-width: 1rem;
  height: 16px;
  font-size: 0.7rem;
  text-align: center;
  line-height: 0.9rem;
  font-weight: 590;
  color: var(--ion-color-primary-contrast);
  background-color: var(--ion-color-primary);
  padding: 0 0.2rem;
}

.navigation-item ion-list.sub-navigation {
  width: 100%;
  margin-bottom: 0.5rem;
  background-color: transparent;
}

/* @media (min-width: 1200px) { */
.sub-navigation {
  display: none;

}

.is-active .sub-navigation,
.is-active-parent .sub-navigation {
  display: block;
}

/* } */

.navigation-item ion-list ion-item ion-label {
  margin: 0;
}
</style>

<style>
.navigation-item .sub-navigation .navigation-item .main-route {
  padding-left: 3.7rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.9rem;
  font-weight: 400;
}

.navigation-item .sub-navigation .navigation-item.is-active .main-route {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.navigation-item .sub-navigation .navigation-item.is-active:first-child .main-route {
  padding-right: 4px;
}

.badge-has-changed .badge::after {
  content: "";
  position: absolute;
  border: 3px solid var(--ion-color-primary);
  width: 30px;
  height: 30px;
  bottom: calc(-15px + 4px);
  right: calc(50% - 18px);
  /* 18 = radius + border */
  border-radius: 30px;
  line-height: 0;
  animation-name: fadeIn;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
}

.badge-has-changed .badge::before {
  content: "";
  position: absolute;
  border: 3px solid var(--ion-color-primary);
  width: 20px;
  height: 20px;
  bottom: calc(-10px + 4px);
  right: calc(50% - 13px);
  /* 18 = radius + border */
  border-radius: 20px;
  line-height: 0;
  animation-name: fadeInStrong;
  animation-duration: 0.7s;
  animation-iteration-count: infinite;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  75% {
    opacity: 0.3;
  }

  100% {
    opacity: 0;
  }
}

@keyframes fadeInStrong {
  0% {
    opacity: 0;
  }

  75% {
    opacity: 0.6;
  }

  100% {
    opacity: 0;
  }
}
</style>